export default __webpack_public_path__ + "static/este1-eb218f044d2599fbb5368082fb3b7405.mp4";